import {RtmMessage} from "agora-rtm-sdk";
import CustomMessage from "./CustomMessage";

export default class MessageBean{
  account='';
  message=null;
  _cacheFile='';
  _background=0;
  beSelf=false;
  _customMessage=null;

  constructor(account,message,beSelf) {
    this._account = account;
    this._message = message;
    this._beSelf = beSelf;
  }


}



// WEBPACK FOOTER //
// ./src/ent/MessageBean.js